/**
 * @removeRatingContainer : function to remove rating container when there is no rating
 */
function removeRatingContainer() {
    $('.product-tile__ratings').each(function () {
        const bvText = $(this).find('.bv_text').text();
        if (bvText && bvText === '0.0') {
            $(this).remove();
        }
    });
}

/**
 * @initBazaarVoice : function to initialize bazaarvoice
 */
function initBazaarVoice() {
    removeRatingContainer();
}

export {
    initBazaarVoice
};